export class CreditReferenceList {



    DR_Celular: string;
    DR_Parentesco: string;
    DR_Primer_Apellido: string;
    DR_Primer_Nombre: string;
    DR_Segundo_Apellido: string;
    DR_Segundo_Nombre: string;
    DR_Telefono: string;
    DR_Telefono_Trabajo: string;
    DR_Telefono_Trabajo_Extension: string;
    isValid: boolean;
    objIdReferencia: string;
    valid: boolean

    constructor() {
        this.DR_Celular = "";
        this.DR_Parentesco = "";
        this.DR_Primer_Apellido = "";
        this.DR_Primer_Nombre = "";
        this.DR_Segundo_Apellido = "";
        this.DR_Segundo_Nombre = "";
        this.DR_Telefono = "";
        this.DR_Telefono_Trabajo = "";
        this.DR_Telefono_Trabajo_Extension = "";
        this.isValid = false;
        this.objIdReferencia = "";
        this.valid = false;
    };

}
